module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/flash-back-video-poster.769aa74a.jpg";